import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { environment } from '../shared/environments/environment';
import { ICategory, ICategoryCreate, ICategoryUpdate } from '../typing/category.interface';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {

    constructor(private http: HttpClient) {
    }

    getCategories(query: Params = {}): Observable<IPaginatedResponse<ICategory>> {
        return this.http.get<IPaginatedResponse<ICategory>>(`${environment.API_BASE_PATH}/categories`, {params: query});
    }

    getCategory(id: number): Observable<ICategory> {
        return this.http.get<ICategory>(`${environment.API_BASE_PATH}/category/${id}`);
    }

    createCategory(category: ICategoryCreate): Observable<ICategory> {
        return this.http.post<ICategory>(`${environment.API_BASE_PATH}/category`, category);
    }

    updateCategory(category: ICategoryUpdate): Observable<ICategory> {
        return this.http.put<ICategory>(`${environment.API_BASE_PATH}/category/${category.id}`, category);
    }

    deleteCategories(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/categories`, {
            body: data
        });
    }

}
